module.exports = __webpack_public_path__ + "img/logo-youmay-min.f50e7c28.svg";